<template>
  <div class="content">
    <div class="list-box">
      <div class="item" v-for="(item,index) in coupons" :key="index">
        <div class="is_used-box" v-if="item.is_used==1">
          <img class="coupon-bg" :src="require('../assets/'+appTheme+'/is_use1.png')" alt="" />
          <div class="item-content">
            <div class="price-box content-center">
              <div class="price">
                <div><span>￥</span>{{item.amount}}</div>
                <div class="hint-num">{{item.desc}}</div>
              </div>
              <div class="conform-to-box">
                <div class="conform-to">{{item.title}}可用</div>
                <!--          <div class="hint-txt" v-if="txtType==1">适用于厨邦酱油</div>-->
                <div class="date">有效期至{{item.use_endtime}}</div>
              </div>
            </div>
          </div>
          <img class="is_used2" :src="require('../assets/'+appTheme+'/is_use2.png')" alt="" />
        </div>
        <template v-else>
          <img class="coupon-bg" :src="require('../assets/'+appTheme+'/ticket_bg.png')" alt="" />
          <div class="item-content">
            <div class="price-box content-center">
              <div class="price">
                <div><span>￥</span>{{item.amount}}</div>
                <div class="hint-num">{{item.desc}}</div>
              </div>
              <div class="conform-to-box">
                <div class="conform-to">{{item.title}}可用</div>
                <!--          <div class="hint-txt" v-if="txtType==1">适用于厨邦酱油</div>-->
                <div class="date">有效期至{{item.use_endtime}}</div>
              </div>
            </div>
          </div>
          <!--    txtType==1：我的优惠券里面 去使用  txtType=0 店铺详情-->
          <div class="btn" v-if="txtType==1" @click="clickBtn(item,index)">去使用</div>
          <div class="btn" v-else @click="clickBtn(item,index)">领取</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "coupon",
  props: ['coupons','txtType'],
  data(){
    return {
      appTheme:this.$store.state.appTheme,
    }
  },
  methods: {
    clickBtn(item,index){
      console.log(item)
      // this.$emit('sendValueToParent',this.value1,this.value2,this.value3,true);传多个值
      this.$emit('sendCoupon',item,index)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-box{
  .item{
    position: relative;width: 688px;margin: 30px auto;
    .coupon-bg{
      width: 688px;height: auto;display: block;
    }
    .item-content{
      position: absolute;left: 50px;top: 51px;z-index: 2;
      .price-box{
        .price{
          font-size: 60px;font-weight: bold;
          color: #FB1819;
          span{
            font-size: 50px;
          }
          .hint-num{
            font-size: 24px;color: #282828;font-weight: 400;
          }
        }
        .conform-to-box{
          font-size: 20px;text-align: left;margin-left: 20px;
          .hint-txt{
            font-size: 22px;color: #FB1819;border-radius:15px;background: #f8f5e0;padding: 6px 15px;display: inline-block;
            margin: 10px 0;
          }
          .conform-to{
            font-size: 30px;font-weight: bold;
          }
        }
      }

    }
    .btn{
      width: 126px;font-size: 26px;padding: 15px 0;text-align: center;position: absolute;right: 31px;z-index: 2;
      top: 65px;
      background: #F4F4F4;
      border-radius: 30px;
    }
    .active-btn{ background: #bababa;}
    .is_used-box{
      .is_used2{
        position: absolute;width: 132px;height: auto;display: block;right: 25px;top: 25px;
      }
      .item-content{
        color: #8C8787;
        .price{
          color: #8C8787;
          .hint-num{
            color: #8C8787;
          }
        }
      }
    }
  }
}

</style>
